
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Icon, MALL_ICONS } from '@mg/micro/vue2'
import PersonalDataFormFields from './PersonalDataFormFields.vue'
import {
  PersonalDataFormType,
  PersonalDataFormFieldsTranslations,
} from './types'
import { ApiValidationErrors } from '~/utils/apolloErrors'

@Component({
  components: {
    Icon,
    PersonalDataFormFields,
  },
})
export default class PersonalDataFormPanel extends Vue {
  @Prop(Object) readonly formType!: PersonalDataFormType
  @Prop(Object) readonly prefill?: {
    firstname: string
    lastname: string
    email: string
  } | null

  @Prop(Boolean) readonly isLoading!: boolean
  @Prop(Boolean) readonly isOpen!: boolean

  @Prop({ type: Object, required: true })
  translations!: PersonalDataFormFieldsTranslations

  @Prop({ type: Object, default: () => ({}) })
  readonly apiErrors!: ApiValidationErrors

  MALL_ICONS = MALL_ICONS
}
